import { FragmentType, graphql, useFragment } from "@/gql"
import { ReviewApplicantsActionFragmentDoc } from "@/gql/graphql"
import InvitesIcon from "../../[id]/(jobOwnerPage)/icons/InvitesIcon"
import UnreviewedApplicationsIcon from "../../[id]/(jobOwnerPage)/icons/UnreviewedApplicationsIcon"
import { ActionRow } from "./ActionRow"

graphql(`
  fragment ReviewApplicantsAction on JobPosting {
    id
    __typename
    unreviewedApplicationCount
    unreadUnreviewedApplicationCount
    invitationCount
  }
`)

export const ReviewApplicants = ({
  jobPostingFragment,
  track,
}: {
  jobPostingFragment: FragmentType<typeof ReviewApplicantsActionFragmentDoc> | null | undefined
  track: (shortcutType: "invites" | "unreviewed") => void
}) => {
  const jobPosting = useFragment(ReviewApplicantsActionFragmentDoc, jobPostingFragment)
  const jobId = jobPosting?.id
  return (
    <>
      <ActionRow
        icon={
          <div className="flex size-10 items-center justify-center rounded-sm bg-bg-2 md:size-6 md:bg-transparent">
            <InvitesIcon width={24} height={24} className="stroke-fg-3" />
          </div>
        }
        text="Invites"
        count={jobPosting?.invitationCount}
        link={`/hire/${jobId}?tab=invites`}
        onClick={() => track("invites")}
      />
      <ActionRow
        icon={
          <div className="flex size-10 items-center justify-center rounded-sm bg-bg-2 md:size-6 md:bg-transparent">
            <UnreviewedApplicationsIcon width={24} height={24} className="stroke-fg-3" />
          </div>
        }
        text="Unreviewed"
        count={jobPosting?.unreviewedApplicationCount}
        newCount={jobPosting?.unreadUnreviewedApplicationCount}
        link={`/hire/${jobId}?tab=applications&filter=unreviewed`}
        onClick={() => track("unreviewed")}
      />
    </>
  )
}
